export const animationSync = (animationName: string | string[]) => {
  const elements = new Set();
  const lastIterationTS: number = now();

  const shouldSync = Array.isArray(animationName)
    ? (event: AnimationEvent) => animationName.indexOf(event.animationName) > -1
    : (event: AnimationEvent) => event.animationName === animationName;

  const animationStart = (event: any) => {
    if (shouldSync(event)) {
      const element = event.target;
      const passed: number = now() - lastIterationTS;
      element.style.setProperty('animation-delay', `${-passed}ms`);
      elements.add(element);
    }
  };

  window.addEventListener('animationstart', animationStart, true);

  return { elements };
};

const now = () => {
  return new Date().getTime();
};
